/**
 * OrdersToolbar Section Component
 *
 * Renders the filter entry point and primary action button for orders listing.
 */

import { FilterByDropdown } from '@components/filters';
import { Button } from '@/components/ui/button';
import { PlusIcon } from '../../../icons';
import type { OrdersToolbarProps } from '../types';

export type { OrdersToolbarProps };

export function OrdersToolbar({
  categories,
  onNewOrder,
  translations,
  className,
}: OrdersToolbarProps) {
  const newOrderLabel = translations?.new_order ?? 'New order';

  return (
    <div className={className}>
      <div className="flex flex-wrap items-center gap-4">
        <FilterByDropdown categories={categories} />

        <Button onClick={onNewOrder}>
          <PlusIcon className="size-5" aria-hidden="true" />
          {newOrderLabel}
        </Button>
      </div>
    </div>
  );
}
